export const CHANNEL_TYPE = {
  META: 'META',
  BEDROCK: 'BEDROCK',
} as const;

export type ChannelType = (typeof CHANNEL_TYPE)[keyof typeof CHANNEL_TYPE];

export const CHANNEL_USAGE_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
} as const;

export type ChannelUsageType =
  (typeof CHANNEL_USAGE_TYPE)[keyof typeof CHANNEL_USAGE_TYPE];

export interface ChannelTypeOption {
  type: ChannelType;
  description: string;
}

export interface ChannelUsageTypeOption {
  type: ChannelUsageType;
  description: string;
}

export const CHANNEL_TYPES: readonly ChannelTypeOption[] = [
  { type: CHANNEL_TYPE.META, description: 'channels.type.meta' },
  { type: CHANNEL_TYPE.BEDROCK, description: 'channels.type.bedrock' },
] as const;

export const CHANNEL_USAGE_TYPES: readonly ChannelUsageTypeOption[] = [
  { type: CHANNEL_USAGE_TYPE.SINGLE, description: 'channels.usageType.single' },
  { type: CHANNEL_USAGE_TYPE.MULTIPLE, description: 'channels.usageType.multiple' },
] as const;
